export function reduceTurn(state, action) {
  switch (action.type) {
    case 'TURN_STARTED':
      return Object.assign({}, state, {
        conversationId: action.conversationId,
        turnId: action.turnId
      }, action.title !== undefined ? {
        title: action.title
      } : {});
    case 'TURN_COMPLETED':
      return Object.assign({}, state, {
        status: 'READY',
        isReconnecting: false
      });
    case 'TURN_ERROR':
      return Object.assign({}, state, {
        status: 'ERROR',
        error: action.error,
        isReconnecting: false
      });
    case 'TURN_ERROR_SOFT':
      return Object.assign({}, state, {
        error: action.error
      });
    case 'CLEAR_ERROR':
      return Object.assign({}, state, {
        error: null
      });
    // Connection-level recovery (e.g. an auth/reconnect after a stale tab wakes)
    // clearing a terminal turn error without a new send. Only meaningful while
    // parked in ERROR: it returns the conversation to a usable READY state and
    // drops the stale error. A no-op in any other status so a late/duplicate
    // recovery cannot disturb an active turn.
    case 'ERROR_RECOVERED':
      return state.status === 'ERROR' ? Object.assign({}, state, {
        status: 'READY',
        error: null,
        isReconnecting: false
      }) : state;
    case 'STATUS_SET':
      return Object.assign({}, state, {
        status: action.status
      });
    case 'RESET_TURN':
      return Object.assign({}, state, {
        conversationId: null,
        turnId: null
      });
    case 'CANCEL_MARK':
      return Object.assign({}, state, {
        cancelled: true
      });
    case 'CANCEL_CLEAR':
      return Object.assign({}, state, {
        cancelled: false
      });
    case 'RECONNECTING_SET':
      return Object.assign({}, state, {
        isReconnecting: true
      });
    case 'TITLE_UPDATED':
      return Object.assign({}, state, {
        title: action.title
      });
    case 'RESET':
      return Object.assign({}, state, {
        conversationId: null,
        turnId: null,
        title: null,
        status: 'READY',
        error: null,
        cancelled: false,
        isReconnecting: false
      });
    default:
      return state;
  }
}